import React, { useState, useEffect, useRef } from 'react'
import Product from './types/Product'

export default function ProductPicker({
	setProducts,
	products,
} :
{ setProducts: (products: Product[]) => void,
	products: Product[],
}) {

	const setQuantity = (product: Product, quantity: number) => {
		setProducts(products.map((p) => {
			return p.id === product.id ? {...p, quantity: quantity } : p
		}))
	}

	return (
		<div className='product-picker'>
			<h2 className='title'>Choose Products</h2>
			{products.map((product) => (
				<div key={product.id} className="product">
					<img src={product.image.cover.url} />
					<div>
						<h3 className='title'>
							{product.title}
						</h3>
						<div className="quantity">
							<h4 className="add" onClick={() => setQuantity(product, product.quantity ? product.quantity + 1 : 1)}>
								+
							</h4>
							<h4>
								{typeof product.quantity !== 'undefined' ? product.quantity : 0}
							</h4>
							{typeof product.quantity !== 'undefined' && product.quantity > 0 && (
								<div className='subtotal'>
									<h4>
										${((product.quantity * product.price)/100).toFixed(2)}
									</h4>
									<h4 className='clear' onClick={() => setQuantity(product, 0)}>
										×
									</h4>
								</div>
							)}
						</div>
					</div>
				</div>
			))}
		</div>
	)
}